module.exports = __webpack_public_path__ + "static/media/JP_RCH_EYELASHES03.80278885.jpg";